import React, { useEffect, useState } from 'react'
import { fetchVideosByTag } from '../../utils/api'

import VideoItem from '../VideoListing/VideoItem'

import './styles/related-videos.scss'

const RelatedVideos = props => {
  const { tags, currentVideoId } = props

  const [videos, setVideos] = useState([])

  const fetchTagVideos = async tags => {
    const results = await Promise.all(tags.map(async tag => {
      return await fetchVideosByTag(tag)
    }))

    const bucket = new Map()
    results.flat(2).forEach(result => {
      const { id, snippet: { resourceId: { videoId } } } = result

      if (id === currentVideoId) {
        return
      }

      if (bucket.has(videoId)) {
        return
      }

      bucket.set(videoId, result)
    })

    console.log(bucket)
    //console.log(Array.from(bucket, ([key, value]) => value))

    //return results.flat(2)
    return Array.from(bucket, ([key, value]) => value)
  }


  useEffect(() => {
    // reinitialize the video array
    setVideos([])

    fetchTagVideos(tags).then(videos => {
      setVideos(videos)
    })

  }, [tags, currentVideoId])

  return (
    <aside className="related-videos">
      <h2 className="section-title section-title--small">related videos</h2>
      {videos.length > 0 && (
        <ul>
          {videos.map(video => {
            const {
              id,
              snippet: {
                resourceId: { videoId },
                thumbnails,
                title,
                publishedAt,
                channelTitle,
              },
            } = video

            return (
              <li
                key={id}
                className="related-videos__single-video video-listing-item">
                <VideoItem
                  id={videoId}
                  title={title}
                  channelTitle={channelTitle}
                  publishedAt={publishedAt}
                  thumbnails={thumbnails}/>
              </li>
            )
          })}
        </ul>
      )}
    </aside>
  )
}

export default RelatedVideos